import { InjectionToken } from '@angular/core';
import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import * as fromMaintenance from '../maintenance/store/maintenance.reducers';

export interface State {
    [fromMaintenance.maintenanceFeatureKey]: fromMaintenance.MaintenanceState;
}

export const ROOT_REDUCERS = new InjectionToken<ActionReducerMap<State>>('Root reducers token', {
    factory: () => ({
        [fromMaintenance.maintenanceFeatureKey]: fromMaintenance.maintenanceModeContextReducer
    })
});

export const metaReducers: MetaReducer<State>[] = [];
